import {NgModule, SecurityContext} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {GridLibAngularComponentModule} from '@gen-nexus-registry/grid-lib-angular/dist/grid-lib-angular-component';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CheckIbanComponent} from './pages/check-iban/check-iban.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularIbanModule} from 'angular-iban';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import {SidebarComponent} from "./components/sidebar/sidebar.component";
import {HeaderComponent} from "./components/header/header.component";
import {MatCardModule} from "@angular/material/card";
import {MessagesComponent} from "./components/messages/messages.component";
import {MessagesService} from "./services/messages.service";
import {LoaderComponent} from "./components/loader/loader.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatSelectModule} from "@angular/material/select";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {NgChartsModule} from 'ng2-charts';

import {HttpInterceptorProviders} from "../interceptors/interceptors-index";
import {HomeComponent} from "./pages/home/home.component";
import {MainContainerComponent} from "./components/main-container/main-container.component";
import {ResultCardComponent} from "./pages/check-iban/result-card/result-card.component";
import {QuicksightComponent} from './pages/quicksight/quicksight.component';
import { EpaComponent } from './pages/epa/epa.component';
import { EpaSectionComponent } from './pages/epa/components/epa-section/epa-section.component';
import { EpaItemCardComponent } from './pages/epa/components/epa-item-card/epa-item-card.component';
import {
  StaticSummaryDataComponent
} from './pages/sic-ania/shared-components/static-summary-data/static-summary-data.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SicAniaModule} from './pages/sic-ania/sic-ania.module';
import {SmsSenderComponent} from './pages/sms-sender/sms-sender.component';
import { QuicksightSicAniaComponent } from './pages/quicksight-sic-ania/quicksight-sic-ania.component';
import { QuicksightSmsSenderComponent } from './pages/quicksight-sms-sender/quicksight-sms-sender.component';
import {SmartSummaryComponent} from "./pages/smart-summary/smart-summary.component";
import {MatTableModule} from "@angular/material/table";
import {MarkdownModule, MarkdownService} from "ngx-markdown";
import {FeedbackModalComponent} from "./pages/smart-summary/feedback-modal/feedback-modal.component";
import { QuicksightSmartSummaryComponent } from './pages/quicksight-smart-summary/quicksight-smart-summary.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    CheckIbanComponent,
    EpaComponent,
    EpaSectionComponent,
    EpaItemCardComponent,
    SidebarComponent,
    HomeComponent,
    HeaderComponent,
    MessagesComponent,
    MainContainerComponent,
    QuicksightComponent,
    SmsSenderComponent,
    QuicksightSicAniaComponent,
    QuicksightSicAniaComponent,
    SmartSummaryComponent,
    FeedbackModalComponent,
    QuicksightSmartSummaryComponent
  ],
  imports: [
    LoaderComponent,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GridLibAngularComponentModule,
    FormsModule,
    ReactiveFormsModule,
    AngularIbanModule,
    HttpClientModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    MatSelectModule,
    NgChartsModule,
    ResultCardComponent,
    SicAniaModule,
    StaticSummaryDataComponent,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatTableModule,
    MarkdownModule.forRoot({
      sanitize: SecurityContext.NONE
    })
  ],
  providers: [MessagesService, HttpInterceptorProviders, MarkdownService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
